// Отмена запросов фильтры +
// Отмена запросов таблицы + 
// Квери + 

import { useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import { useState, useEffect, useRef } from 'react';
import { TableBox, ButtonBasic, DropDownSelector, Tabs, SearchComponent, Checkbox } from "@lk-gtcom/ecomlab-components";
import { useDataTable } from '../../common/hooks';
import useGeneralStore from '../../store/general';
import customHeaders, { getSpace } from '../../common/headers';
import { ModalAddNewField } from '../SettingCostPrice/ModalAddNewField/ModalAddNewField';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { ModalСonfirmation } from './ModalСonfirmation/ModalСonfirmation'
import { ModalСonfirmationTemplate } from './ModalСonfirmationTemplate/ModalСonfirmationTemplate'
import { ModalAlert } from '../../components/Modal/ModalAlert/ModalAlert';
import { useLocation } from 'react-router-dom';
import './SettingCostPrice.scss'
// Отмена запросов для фильтров
import { RequestController } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { options_prop_mp } from '../../common/globalVariables';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { usePushNotifications } from '../../common/pushNotification';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
    {
        label: 'Модель данных',
        value: 'parameters'
    },
    {
        label: 'Установка себестоимости',
        value: 'setting'
    }
]

const btns = [
    { label: 'Общее для всех', value: 'total' },
    { label: 'По товарам', value: 'product' }
]

const optionPropsCostPrice = [
    {
        label: 'C установленной себестоимостью',
        value: 'with_cost_price'
    },
    {
        label: 'Без себестоимости',
        value: 'without_cost_price'
    },
    {
        label: 'Все товары',
        value: 'all'
    }
]

const SettingCostPrice = ({ }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
    const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'setting-cost-price');
    const requestControllerRef = useRef(new RequestController());
    const location = useLocation();

    // Рефы
    const fileInputRef = useRef(null);

    const [pageValue, setPageValue] = useState(btn_tab[0].value)
    const [status, setStatus] = useState(btns?.[0]?.value)
    const [currentRow, setСurrentRow] = useState(null)
    const [statusBtn, setStatusBtn] = useState(false)

    // Фильтры
    const filterConfig = [
        { key: 'mp', type: 'single' },
        { key: 'api', type: 'single' },
        { key: 'category', type: 'multi' },
        { key: 'brand', type: 'multi' },
        { key: 'cost', type: 'single' },
        { key: 'search', type: 'single' },
        { key: 'zero', type: 'single' },
        { key: 'loadCost', type: 'single' },
    ];

    const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
    const [isFilterRequest, setIsFilterRequest] = useState(false);

    const [apiData, setApiData] = useState([]);
    const [brandData, setBrandData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);

    const [apiPage, setApiPage] = useState(1);
    const [brandPage, setBrandPage] = useState(1);
    const [categoryPage, setCategoryPage] = useState(1);

    const [apiQuery, setApiQuery] = useState('');
    const [brandQuery, setBrandQuery] = useState('');
    const [categoryQuery, setCategoryQuery] = useState('');

    const [selectedMp, setSelectedMp] = useState(options_prop_mp[0]);
    const [selectedApi, setSelectedApi] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedCostPrice, setSelectedCostPrice] = useState([]);

    const [totalApi, setTotalApi] = useState(0);
    const [totalCategory, setTotalCategory] = useState(0);
    const [totalBrand, setTotalBrand] = useState(0)

    // Checkbox
    const [isZero, setIsZero] = useState(false)
    const [isLoadCost, setIsLoadCost] = useState(false)
    const [isClear, setIsClear] = useState(false);

    // Search
    const [searchValue, setSearchValue] = useState('');
    const [searchData, setSearchData] = useState([]);
    const [defaultSearchValue, setDefaultSearchValue] = useState('')
    const [isLoadingTemplate, setIsLoadingTemplate] = useState(false)

    const activeTab = useParams()['*']

    // Таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
    const { total, loading, filters } = tableProps;
    const [tableUrl, setTableUrl] = useState('');
    const [tableBody, setTableBody] = useState(null);
    const [loadingUpload, setLoadingUpload] = useState(false)

    // Modal
    const [isModalAddNewField, setIsModalAddNewField] = useState(false)
    const [isModalTemplate, setIsModalTemplate] = useState(false)
    const [isModalAlert, setIsModalAlert] = useState(false)
    const [textModalAlert, setTextModalAlert] = useState('')
    const [isModalConfirm, setIsModalConfirm] = useState()

    const [modelsAttribute, setModelsAttribute] = useState([])

    // Инициализация фильтров из URL параметров при первом рендере
    const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

    // Обработка ошибок
    const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();


    useEffect(() => {
        if (!isReady) return;
        if (!isInitialLoadFromURL) {
            setIsInitialLoadFromURL(true);

            // Обновляем все состояния фильтров
            setTimeout(() => {
                if (urlParams.mp) setSelectedMp(urlParams.mp)
                if (urlParams.api) setSelectedApi(urlParams.api)
                if (urlParams.category) setSelectedCategory(urlParams.category)
                if (urlParams.brand) setSelectedBrand(urlParams.brand)
                if (urlParams.cost) setSelectedCostPrice(urlParams.cost)
                if (urlParams.zero) setIsZero(urlParams.zero?.value)
                if (urlParams.loadCost) setIsLoadCost(urlParams.loadCost?.value)
                if (urlParams.search) {
                    setSearchValue(urlParams.search?.value)
                    setDefaultSearchValue({
                        value: urlParams.search?.value,
                        label: urlParams.search?.label
                    })
                }

                // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
                setIsFilterRequest(prev => !prev);
                if (Object.keys(urlParams).length > 0) {
                    setIsTableRequest(prev => !prev);
                }
            }, 10);
        }
    }, [urlParams, isReady]);

    // Первая инициализация url
    useEffect(() => {
        if (!isReady) return;
        const page_url = {
            category: urlParams?.category || selectedCategory,
            brand: urlParams?.brand || selectedBrand,
            loadCost: urlParams?.loadCost ? urlParams.loadCost?.value : null,
            zero: urlParams?.zero ? urlParams.zero?.value : null,
            search: urlParams?.search ? urlParams.search?.value : null,
        }
        updateURL({
            mp: urlParams?.mp || selectedMp,
            api: urlParams?.api || selectedApi,
            category: null,
            brand: null,
            loadCost: null,
            zero: null,
            search: null,
            ...pageValue === 'setting' ? page_url : {}
        })
    }, [pageValue, isReady]);

    const apiFilter = () => {
        const controller = requestControllerRef.current.createController('api');

        fetchApiFilterVer3({
            controller,
            selectedSpace: selectedSpace?.value,
            setTotal: setTotalApi,
            page: apiPage,
            setApiData: setApiData,
            set: setApiData,
            searchParam: apiQuery,
            selectedApi,
            selectedShop: selectedMp,
            filter: 'api_id',
        })?.finally(() => {
            requestControllerRef.current.removeController('api');
        })
    };

    const categoryFilter = () => {
        const controller = requestControllerRef.current.createController('category');

        fetchApiFilterVer3({
            controller,
            selectedSpace: selectedSpace?.value,
            setTotal: setTotalCategory,
            page: categoryPage,
            selectedShop: selectedMp,
            apiData,
            selectedApi,
            selectedCategory,
            selectedBrand,
            set: setCategoryData,
            setCategoryData: (e) => setCategoryData(e),
            searchParam: categoryQuery,
            filter: 'category',
        })?.finally(() => {
            requestControllerRef.current.removeController('category');
        })
    };

    const brandFilter = () => {
        const controller = requestControllerRef.current.createController('brand');

        fetchApiFilterVer3({
            controller,
            selectedSpace: selectedSpace?.value,
            setTotal: setTotalBrand,
            apiData,
            categoryData,
            selectedApi,
            selectedShop: selectedMp,
            selectedCategory,
            selectedBrand,
            page: brandPage,
            searchParam: brandQuery,
            set: setBrandData,
            setBrandData: (e) => setBrandData(e),
            filter: 'brand',
        })?.finally(() => {
            requestControllerRef.current.removeController('brand');
        })
    };

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        apiFilter();
    }, [isFilterRequest, apiPage, apiQuery]);

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        categoryFilter();
    }, [isFilterRequest, categoryPage, categoryQuery]);

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        brandFilter();
    }, [isFilterRequest, brandPage, brandQuery]);

    useEffect(() => {
        return () => {
            // Отменяем все активные запросы фильтров
            requestControllerRef.current.abortAll();
        };
    }, []);

    const handleSaveOnePrice = (e) => {
        const { inputEvent, actionEvent, setStatus } = e;
        const offerId = inputEvent?.id;
        const apiId = actionEvent?.[0]?.api_id;
        const mpId = actionEvent?.[0]?.mp_id;
        let newPrice = +inputEvent?.value;
        const attrName = actionEvent?.[2]

        if (newPrice) {
            setStatus('loading');
            fetchSetCostPrice(apiId, mpId, offerId, attrName, newPrice, setStatus);
        } else {
            setStatus('error');
        }
    };

    const onDelete = (e) => {
        if (pageValue == 'parameters') {
            const { api_id, mp_id } = e
            fetchDeleteModels(api_id, mp_id, e?.["Название"])
        } else {
            const { api_id, mp_id, offer_id } = e
            fetchDelete(api_id, mp_id, offer_id)
        }

    }

    const onEdit = (e) => {
        if (e?.['Название'] == 'Себестоимость') {
            alert('Поле с названием "Себестоимость" изменить нельзя')
        } else {
            setСurrentRow(e)
            setIsModalAddNewField(true)
        }
    }

    const handleSearch = useCallback((e) => {
        const abortController = new AbortController();
        fetchSearch(e, abortController);
        return () => abortController.abort();
    });

    const contextMenuArr = [
        ...(pageValue == 'parameters'
            ? [
                { label: 'Редактировать', onClick: onEdit },
            ]
            : []),
        { label: 'Удалить', onClick: onDelete },
    ];

    // Поиск
    const fetchSearch = ([search, page = 1], abortController = new AbortController()) => {
        let url = `https://apps0.ecomru.ru:4449/v2/mp-products/filters/offer-id-name`

        const body = JSON.stringify({
            api_id_list: getValueMultiFilter(selectedApi),
            category_id_list: getValueMultiFilter(selectedCategory),
            brand_id_list: getValueMultiFilter(selectedBrand),
            page: page,
            limit: 10,
            search_param: search,
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw Error(JSON.stringify(res.json()));
                }
            })
            .then((json) => {
                setSearchData(json?.filter_data?.map(({ id, name }) => ({ label: name, value: id })));
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Таблица с параметрами
    const fetchTableData = (params, abortController = new AbortController()) => {
        if (selectedApi?.value) {
            let sort
            let filtersParam

            if (params) {
                [sort, filtersParam] = params
            }

            setLoading(true)

            let url = `https://apps1.ecomru.ru:4655/v1/user-price-attrs/${pageValue == 'parameters' ? 'models' : 'values'}/table${sort?.length > 0 ? '?order_param=' + sort[0] + '&order_direction=' + sort[1] : ''}`

            let offer_id_list = pageValue == 'parameters' ? {} : { offer_id_list: searchValue ? [searchValue] : ['all'] }

            const body = JSON.stringify({
                limit: paginatorRef?.current?.limit,
                page: paginatorRef?.current?.page,
                filters: filtersParam,
                mp_id: selectedMp?.value,
                api_id: selectedApi?.value,
                category_id_list: getValueMultiFilter(selectedCategory),
                brand_id_list: getValueMultiFilter(selectedBrand),
                ...offer_id_list,
                cost_price_filter: selectedCostPrice?.value || 'all',
                without_zero_stock: isZero
            })

            fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
                .then(async (res) => {
                    const data = await res.json();
                    if (!res.ok) {
                        const errorMessage = data.detail || 'Неизвестная ошибка';
                        if (res.status === 428) {
                            alert('Модели атрибутов не найдены для этого магазина')
                        } else {
                            console.log(`Ошибка загрузки: ${errorMessage}`);
                        }
                        resetTable()
                        throw new Error(`Upload failed with status ${res.status}: ${errorMessage}`);
                    }
                    return data;
                })
                .then(json => {
                    setTable(json)
                    setTableUrl(json?.tableUrl)
                    setTableBody(json?.tableBody)
                })
                .catch(err => console.error(err))
                .finally(() => {
                    if (abortController.signal.aborted) return
                    setLoading(false)
                })
        }
    }

    // Получение статуса кнопки
    const fetchGetStatus = () => {
        let url = 'https://apps1.ecomru.ru:4655/v1/user-price-attrs/models/has-basic'

        const body = JSON.stringify({
            mp_id: selectedMp?.value,
            api_id: selectedApi?.value
        })

        fetch(url, { method: 'POST', headers, body })
            .then((res) => res.json())
            .then((json) => {
                setStatusBtn(json?.has_basic_models)
            })
            .catch((err) => console.error(err))
            .finally(() => { });
    };

    // Получение статуса чекбокса
    const fetchGetStatusLoadCost = () => {
        if (selectedApi?.value) {
            let url = 'https://apps1.ecomru.ru:4655/v1/user-price-attrs/master-cost-usage/info'

            const body = JSON.stringify({
                mp_id: selectedMp?.value,
                api_id: selectedApi?.value
            })

            fetch(url, { method: 'POST', headers, body })
                .then((res) => res.json())
                .then((json) => {
                    const { use_master_cost } = json
                    setIsLoadCost(use_master_cost)
                })
                .catch((err) => console.error(err))
                .finally(() => { });
        }
    };

    // Запись статуса чекбокса
    const fetchSetStatusLoadCost = (status) => {
        let url = 'https://apps1.ecomru.ru:4655/v1/user-price-attrs/master-cost-usage/update'

        const body = JSON.stringify({
            mp_id: selectedMp?.value,
            api_id: selectedApi?.value,
            use_master_cost: status
        })

        fetch(url, { method: 'POST', headers, body })
            .then((res) => res.json())
            .then((json) => {

            })
            .catch((err) => console.error(err))
            .finally(() => { });
    };

    // Запись значений
    const fetchSetCostPrice = (apiId, mpId, offerId, attrName, newPrice, setStatus) => {
        let url = 'https://apps1.ecomru.ru:4655/v1/user-price-attrs/values'

        const body = JSON.stringify({
            mp_id: mpId,
            api_id: apiId,
            offer_id: offerId,
            attributes: [
                {
                    attribute_name: attrName?.split(',')?.[0],
                    value: newPrice
                }
            ]
        }
        );

        fetch(url, { body, method: 'POST', headers })
            .then((res) => {
                if (res.ok) {
                    setStatus('success')
                    return res.json();
                } else {
                    throw Error(JSON.stringify(res.json()));
                }
            })
            .then((json) => {
                console.log(json)
            })
            .catch((err) => {
                setStatus('error');
                console.error(err);
            });
    };

    // Добавьте базовые атрибуты моделей и установите для них единицы измерения
    const fetchAddValue = () => {
        if (selectedApi?.value) {
            let url = `https://apps1.ecomru.ru:4655/v1/user-price-attrs/models/basic`

            const body = JSON.stringify({
                api_id: selectedApi?.value,
                mp_id: selectedMp?.value
            });

            fetch(url, { body, method: 'POST', headers })
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw Error(JSON.stringify(res.json()));
                    }
                })
                .then((json) => {
                    setTimeout(() => fetchTableData(), 500)
                    setTimeout(() => fetchGetStatus(), 500)
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    };

    // Удаление параметра
    const fetchDelete = (apiId, mpId, offer_id) => {
        if (selectedApi?.value) {
            let url = `https://apps1.ecomru.ru:4655/v1/user-price-attrs/values`

            const body = JSON.stringify({
                mp_id: mpId,
                api_id: apiId,
                offer_id
            });

            fetch(url, { body, method: 'DELETE', headers })
                .then((res) => {
                    if (res.ok) {
                        setTimeout(() => fetchTableData(), 500)
                        return res.json();
                    } else {
                        throw Error(JSON.stringify(res.json()));
                    }
                })
                .then((json) => {
                    setTimeout(() => fetchTableData(), 500)
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    }

    // Удаление модели
    const fetchDeleteModels = (apiId, mpId, attribute_name) => {
        if (selectedApi?.value) {
            let url = `https://apps1.ecomru.ru:4655/v1/user-price-attrs/models`

            const body = JSON.stringify({
                mp_id: mpId,
                api_id: apiId,
                attribute_name
            });

            fetch(url, { body, method: 'DELETE', headers })
                .then((res) => {
                    if (res.ok) {
                        setTimeout(() => fetchTableData(), 500)
                        return res.json();
                    } else {
                        throw Error(JSON.stringify(res.json()));
                    }
                })
                .then((json) => {
                    setTimeout(() => fetchTableData(), 500)
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    }

    // Скачать шаблон цен
    const fetchGetTemplate = async () => {
        setIsLoadingTemplate(true)
        const url = `https://apps1.ecomru.ru:4655/v1/user-price-attrs/values/excel-template`;

        const body = JSON.stringify({
            mp_id: selectedMp?.value,
            api_id: selectedApi?.value
        })

        fetch(url, { method: 'POST', body, headers })
            .then((res) => {
                if (!res.ok) throw new Error('Export failed');

                const contentDisposition = res.headers.get('Content-disposition');
                let filename = 'offer_price_parameters.xlsx'; // значение по умолчанию

                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1];
                    }
                }

                return res.blob().then(blob => ({ blob, filename }));
            })
            .then(({ blob, filename }) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error('Export error:', err);
                }
            })
            .finally(() => { setIsLoadingTemplate(false) });
    };

    // Скачать шаблон цен
    const fetchGetTemplateWithFilters = async () => {
        setIsLoadingTemplate(true)
        const url = `https://apps1.ecomru.ru:4655/v1/user-price-attrs/values/get-excel`;


        let offer_id_list = pageValue == 'parameters' ? {} : { offer_id_list: searchValue ? [searchValue] : ['all'] }

        const body = JSON.stringify({
            limit: paginatorRef?.current?.limit,
            page: paginatorRef?.current?.page,
            mp_id: selectedMp?.value,
            api_id: selectedApi?.value,
            category_id_list: getValueMultiFilter(selectedCategory),
            brand_id_list: getValueMultiFilter(selectedBrand),
            ...offer_id_list,
            cost_price_filter: selectedCostPrice?.value || 'all',
            without_zero_stock: isZero,
            filters: []
        })

        fetch(url, { method: 'POST', body, headers })
            .then((res) => {
                if (!res.ok) throw new Error('Export failed');

                const contentDisposition = res.headers.get('Content-disposition');
                let filename = 'offer_price_parameters_with_filters.xlsx'; // значение по умолчанию

                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1];
                    }
                }

                return res.blob().then(blob => ({ blob, filename }));
            })
            .then(({ blob, filename }) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error('Export error:', err);
                }
            })
            .finally(() => { setIsLoadingTemplate(false) });
    };

    const [selectedFile, setSelectedFile] = useState(false)

    const handleFileChange = async (e) => {
        setIsModalConfirm(true)
        setSelectedFile(e.target.files[0])
    };

    // Загрузить шаблон
    const onUploadFileToPromotion = (file, status) => {
        if (!file) {
            return;
        }
        setLoadingUpload(true)
        addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')

        const url = `https://apps1.ecomru.ru:4655/v1/user-price-attrs/values/by-excel?mp_id=${selectedMp?.value}&api_id=${selectedApi?.value}&replace_old=${status}`;

        const formData = new FormData();
        formData.append('file', file);

        const updatedHeaders = { ...headers };
        delete updatedHeaders['Content-Type'];

        fetch(url, { method: 'POST', updatedHeaders, headers: updatedHeaders, body: formData })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    const errorMessage = data.detail;
                    addErrorPush(`Ошибка загрузки: ${errorMessage}`);
                    throw new Error(`Upload failed: ${res.statusText}`);
                } else {
                    return data;
                }
            })
            .then((data) => {
                setTextModalAlert(JSON.stringify(data))
                addSuccessPush('Файл успешно загружен')
                setTimeout(() => fetchTableData(), 1000)
                if (fileInputRef.current) fileInputRef.current.value = ''
            })
            .catch((err) => {
                console.error(err);
                if (fileInputRef.current) fileInputRef.current.value = ''
            })
            .finally(() => {
                setLoadingUpload(false)
                setSelectedFile(null)
            });
    };

    const resetTable = () => {
        paginatorRef.current?.reset();
        paginatorRef.current?.setTotal(0);
        setSort({});
        setHeaders([]);
        setFetchedData([]);
    };

    useEffect(() => {
        if (!isModalAddNewField) {
            const abortController = new AbortController()
            fetchTableData([], abortController)
            return () => abortController.abort()
        }
    }, [status, pageValue, searchValue, isZero, isTableRequest, isModalAddNewField]);


    useEffect(() => {
        setPageValue(activeTab)
    }, [activeTab])

    useEffect(() => {
        fetchGetStatusLoadCost()
    }, [selectedApi, selectedBrand]);

    return (
        <>
            {isModalAlert && <ModalAlert
                title={textModalAlert}
                setIsModal={(e) => setIsModalAlert(e)}
            />}

            {isModalAddNewField && <ModalAddNewField
                models={modelsAttribute}
                status={status}
                selectedApi={selectedApi}
                selectedMp={selectedMp}
                setIsModal={setIsModalAddNewField}
                currentRow={currentRow}
                setСurrentRow={setСurrentRow}
            />}

            {isModalTemplate &&
                <ModalСonfirmationTemplate
                    setIsModal={setIsModalTemplate}
                    fetchGetTemplate={fetchGetTemplate}
                    fetchGetTemplateWithFilters={fetchGetTemplateWithFilters}
                />}

            {isModalConfirm && <ModalСonfirmation
                setIsModal={setIsModalConfirm}
                onUploadFile={onUploadFileToPromotion}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
            />}

            <div className='setting-cost-price'>
                <TitlePage
                    title={'Установка себестоимости'}
                />

                <FilterContainer
                    loading={isSaved}
                    saveFilters={saveFilters}
                    clearSavedFilters={clearSavedFilters}
                    hasSavedFilters={hasSavedFilters}
                    onReset={(e) => {
                        setSelectedMp([])
                        setSelectedApi([])
                        setSelectedBrand([])
                        setSelectedCategory([])
                        setSelectedCostPrice([])
                        updateURL({
                            mp: null,
                            api: null,
                            category: null,
                            brand: null,
                            cost: null,
                            search: null,
                            zero: null,
                            loadCost: null
                        });
                        setIsTableRequest(!isTableRequest)
                        setIsFilterRequest(!isFilterRequest);
                    }}
                >
                    <DropDownSelector
                        options_prop={options_prop_mp}
                        state={selectedMp}
                        setState={setSelectedMp}
                        total={options_prop_mp?.length}
                        placeholder="Площадка"
                        onBlur={() => {
                            updateURL({ mp: selectedMp });
                            apiFilter()
                            brandFilter()
                            categoryFilter()
                            fetchGetStatus()
                            setIsTableRequest(!isTableRequest)
                        }}
                    />

                    <DropDownSelector
                        options_prop={apiData}
                        state={selectedApi}
                        setState={setSelectedApi}
                        placeholder="Магазин"
                        total={totalApi}
                        fetchCallback={setApiPage}
                        setInputChange={setApiQuery}
                        inputRef={true}
                        onBlur={() => {
                            updateURL({ api: selectedApi });
                            brandFilter()
                            categoryFilter()
                            fetchGetStatus()
                            setIsTableRequest(!isTableRequest)
                        }}
                    />

                    {pageValue != 'parameters' ?
                        <>
                            <DropDownSelector
                                options_prop={categoryData}
                                state={selectedCategory}
                                setState={setSelectedCategory}
                                placeholder="Категория"
                                total={totalCategory}
                                multi={true}
                                fetchCallback={setCategoryPage}
                                setInputChange={setCategoryQuery}
                                onBlur={() => {
                                    updateURL({ category: selectedCategory });
                                    brandFilter()
                                    setIsTableRequest(!isTableRequest)
                                }}
                            />

                            <DropDownSelector
                                options_prop={brandData}
                                state={selectedBrand}
                                setState={setSelectedBrand}
                                placeholder="Бренд"
                                total={totalBrand}
                                multi={true}
                                fetchCallback={setBrandPage}
                                setInputChange={setBrandQuery}
                                onBlur={() => {
                                    updateURL({ brand: selectedBrand });
                                    setIsTableRequest(!isTableRequest)
                                }}
                            />

                            <DropDownSelector
                                options_prop={optionPropsCostPrice}
                                state={selectedCostPrice}
                                setState={setSelectedCostPrice}
                                placeholder="Cебестоимость"
                                onBlur={() => {
                                    updateURL({ cost: selectedCostPrice });
                                    setIsTableRequest(!isTableRequest)
                                }}
                            />

                            <SearchComponent
                                searchValue={searchValue}
                                errSearch={false}
                                placeholder="Искать по артикулу или названию"
                                errText="Неверный артикул или название"
                                setSearchValue={setSearchValue}
                                fetchData={(e) => setIsTableRequest(!isTableRequest)}
                                fetchCallback={handleSearch}
                                data={searchData}
                                callbackOnReset
                                onClearDependence={[isFilterRequest]}
                                updateURL={updateURL}
                                value={defaultSearchValue}
                            />

                            <Checkbox
                                disabled={!selectedApi || !selectedBrand}
                                value={isLoadCost}
                                onChange={(e) => {
                                    if (!selectedApi?.value || !selectedMp?.value) {
                                        addErrorPush('Выберите площадку и магазин')
                                        setIsLoadCost(false)
                                    } else {
                                        updateURL({
                                            loadCost: {
                                                label: e,
                                                value: e
                                            }
                                        });
                                        setIsLoadCost(e)
                                        fetchSetStatusLoadCost(e)
                                    }
                                }}>
                                Загружать себестоимость из цен мастер товаров
                            </Checkbox>

                            <Checkbox
                                value={isZero}
                                onChange={(e) => {
                                    updateURL({
                                        zero: {
                                            label: e,
                                            value: e
                                        }
                                    });
                                    setIsZero(e)
                                }}>
                                Без 0 остатков
                            </Checkbox>
                        </>
                        :
                        <ButtonBasic
                            green
                            disabled={!selectedApi?.value || !selectedMp?.value || statusBtn}
                            // disabled={statusBtn}
                            text='Создать модель затрат'
                            onClick={fetchAddValue}
                        />}
                </FilterContainer>

                <Tabs
                    query={location?.search}
                    tabs={btn_tab}
                    pageValue={pageValue} />

                <TableBox
                    tableUrl={tableUrl}
                    tableBody={tableBody}
                    ref={paginatorRef}
                    paginator={true}
                    {...tableProps}
                    fetchCallback={fetchTableData}
                    tableHeaders={headers}
                    onInputAction={(e) => handleSaveOnePrice(e)}
                    contextMenuArr={contextMenuArr}
                    child={
                        <>
                            {
                                pageValue == 'parameters' ?
                                    <ButtonBasic
                                        disabled={!selectedApi?.value}
                                        whiteGreen
                                        width='auto'
                                        size='32px'
                                        text={'+ Добавить поле'}
                                        onClick={(e) => {
                                            setIsModalAddNewField(true)
                                        }}
                                    />
                                    :
                                    <>
                                        <ButtonBasic
                                            disabled={!selectedApi?.value || !selectedMp?.value || isLoadingTemplate}
                                            blue
                                            text='Шаблон загрузки Excel'
                                            size='32px'
                                            onClick={() => setIsModalTemplate(true)}
                                        />

                                        <div className='setting-cost-price__btn-upload'>
                                            <ButtonBasic
                                                disabled={!selectedApi?.value || !selectedMp?.value}
                                                green
                                                text='Загрузить'
                                                size='32px'
                                                loading={loadingUpload}
                                            />

                                            {(selectedApi?.value && selectedMp?.value) && <input
                                                type="file"
                                                id="fileInput"
                                                onChange={handleFileChange}
                                                ref={fileInputRef}
                                            />}
                                        </div>
                                    </>
                            }

                        </>
                    }
                />
            </div>
        </>
    )
}

export { SettingCostPrice }